
import {
  LOADING_LIST_RENDA_MENSAL,
  SET_LIST_RENDA_MENSAL,
  LOADING_LIST_PATRIMONIO,
  SET_LIST_PATRIMONIO
} from './types';

const initialState = {
  loadingListRendaMensal: false,
  loadingListPatrimonio: false,
  dropdownDadosRendaMensalList: [],
  dropdownDadosPatrimonioList: []
}

export default function rendaPatrimonioReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LIST_PATRIMONIO:
      return { ...state, dropdownDadosPatrimonioList: action.payload }
    case LOADING_LIST_PATRIMONIO:
      return { ...state, loadingListPatrimonio: action.payload }

    case SET_LIST_RENDA_MENSAL:
      return { ...state, dropdownDadosRendaMensalList: action.payload }
    case LOADING_LIST_RENDA_MENSAL:
      return { ...state, loadingListRendaMensal: action.payload }

   default:
      return state
  }
}
